import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "../lib/api";

export default function ChangePassword() {
  const { changePassword, user } = useAuth();
  const navigate = useNavigate();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (next.length < 10) return setErr("New password must be at least 10 characters.");
    if (next !== confirm) return setErr("Passwords do not match.");
    setBusy(true);
    try {
      await changePassword(cur, next);
      toast.success("Password updated.");
      navigate("/");
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-md">
        <div className="border border-border rounded-xl bg-card p-6 shadow-sm">
          <h2 className="font-display text-xl font-semibold tracking-tight mb-1">
            Set a new password
          </h2>
          <p className="text-sm text-muted-foreground mb-6">
            For security, please change the temporary password before you continue.
          </p>

          <form onSubmit={submit} className="space-y-4" data-testid="change-password-form"
                autoComplete="on">
            {/* Hidden username field so password managers scope the saved
                credential to this specific account (prevents the "saved the
                TEMP password" class of bug seen on the forced-change screen). */}
            <input type="text" name="username" value={user?.email || ""} readOnly
                   autoComplete="username" aria-hidden="true" tabIndex={-1}
                   style={{ display: "none" }} />
            <div>
              <Label htmlFor="cur">Current password</Label>
              <Input id="cur" type="password" required value={cur}
                     autoComplete="current-password"
                     onChange={(e) => setCur(e.target.value)} data-testid="cp-current" />
            </div>
            <div>
              <Label htmlFor="next">New password (min 10 chars)</Label>
              <Input id="next" type="password" required value={next}
                     autoComplete="new-password"
                     onChange={(e) => setNext(e.target.value)} data-testid="cp-new" />
            </div>
            <div>
              <Label htmlFor="confirm">Confirm new password</Label>
              <Input id="confirm" type="password" required value={confirm}
                     autoComplete="new-password"
                     onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" />
            </div>
            {err && <div className="text-sm text-rose-500" data-testid="cp-error">{err}</div>}
            <Button type="submit" disabled={busy} className="w-full h-11" data-testid="cp-submit">
              {busy ? "Saving…" : "Save new password"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
